import { Fill, Stroke, Style, Text } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { HoleStatus, HoleTypeQuality } from "src/app/services/hole.service";

export class CartStyleUtile {



   //POLYGONE
   polygoneStyleByColor(couleurPolygone): Style {
    var style = new Style({
      stroke: new Stroke({
        width: 2,
        color: 'hsl(' + couleurPolygone + ')'
      }),
      fill: new Fill({
        color: 'hsl(' + couleurPolygone + ', 0.5)'
      })
    });
    return style;
  }


  static polygoneStyleByType(polygoneType: number, color:string): Style {
    var style;
    if (4 == polygoneType) {
      style = new Style({
        stroke: new Stroke({
          width: 2,
          color: 'red',
        })        
      });
    }
    else {
      style  = new Style({
        stroke: new Stroke({
          width: 2,
          color: 'hsl(' + color + ')',

        }),
        fill: new Fill({
         color: 'hsl(' + color + ', 0.5)',

        })
      });
    }
    return style;
  }


  static polygoneStyleHover(fillColor?: string): Style{
    const selectStyle = new Style({
      fill: new Fill({
        color: fillColor ?? 'rgba(145, 40, 59, 0.8)',
      }),
      stroke: new Stroke({
        color: 'rgba(255, 255, 255, 0.85)',
        width: 3,
      }),
    });

    return selectStyle;
  }


  
  //HOLE
  static zoiStyleHover(name?: string): Style {
    return new Style({
      fill: new Fill({
        color: 'rgba(255, 165, 0, 0.4)',
      }),
      stroke: new Stroke({
        color: 'rgba(255, 255, 255, 0.85)',
        width: 3,
      }),
      text: name ? new Text({
        font: 'bold 13px Calibri,sans-serif',
        text: name,
        fill: new Fill({ color: '#fff' }),
        backgroundFill: new Fill({ color: 'rgba(255, 140, 0, 0.9)' }),
        padding: [3, 5, 3, 5],
        overflow: true,
      }) : undefined,
    });
  }

  static holeStyleHover(): Style{
    const selectStyle = new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({color: 'rgba(255, 255, 255, 0.5)'}),
        stroke: new Stroke({color:'rgba(255, 0, 0, 0.9)'})
      })
    })

    return selectStyle;
  }


  // static holeStyleByStatus(status: string): Style{
  //   const clr = this.holeStyleColorByStatus(status)
  //  return new Style({
  //     image: new CircleStyle({
  //       radius: 6,
  //       fill: new Fill({color: 'rgba('+clr+', 0.4)'}),
  //       stroke: new Stroke({color:'rgba('+clr+', 1)'})
  //     })
  //   })
  // }


  public static  holeStyleColorByStatus(status: string): string{
    
      switch (status as  HoleStatus) {
        case HoleStatus.UNSET:
          return '43, 43, 43 ';
        case HoleStatus.PLANNED:
          return '244, 252, 252';
        case HoleStatus.DRILLED:
          return '9, 57, 219';
        case HoleStatus.LOADING:
          return '210, 138, 11';
        case HoleStatus.LOADED:
          return '251, 17, 17';
        case HoleStatus.MISSING:
          return '187, 42, 220';
        case HoleStatus.TO_REDRILL:
          return '237, 253, 7 ';
        case HoleStatus.BLASTED:
          return '30, 230, 70';
        case HoleStatus.COLLAPSED:
          return '77, 77, 77';
        case HoleStatus.TOADJUST:
          return '255, 200, 200';
        case HoleStatus.REDRILLED:
          return '0, 202, 247';
        default:
          return '255, 255, 255 ';
      }
  }

  public static iconHoleQuality(type: string): string {
    switch (type as HoleTypeQuality) {
      case HoleTypeQuality.Head:
        return 'assets/icon/hole_head.svg';
      case HoleTypeQuality.Length:
        return 'assets/icon/hole_length.svg';
      case HoleTypeQuality.Toe:
        return 'assets/icon/hole_toe.svg';
    }
  }
}